import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import { useImages } from '../../context/imagesContext';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const LogoCarousel = () => {
  const { images, loading } = useImages();
  const [isHovered, setIsHovered] = useState(false);

  if (loading) {
    return (
      <div className="w-full py-8 text-center animate-pulse">
        <div className="inline-block px-3 py-1 bg-gray-200 rounded-md">
          Cargando logos...
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full bg-gradient-to-b from-gray-50 to-gray-100 py-6 border-t border-gray-200">
      {/* Overlay para el efecto de difuminado en los extremos */}
      <div className="absolute top-0 left-0 w-36 h-full bg-gradient-to-r from-gray-100 to-transparent z-10"></div>
      <div className="absolute top-0 right-0 w-36 h-full bg-gradient-to-l from-gray-100 to-transparent z-10"></div>
      
      <div className="max-w-7xl mx-auto px-2">
        
        <Swiper
          modules={[Autoplay, EffectCoverflow]}
          effect="coverflow"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
          slidesPerView={4}
          spaceBetween={40}
          centeredSlides={true}
          autoplay={{ 
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          loop={true}
          breakpoints={{
            640: { slidesPerView: 3, spaceBetween: 30 },
            768: { slidesPerView: 4, spaceBetween: 40 },
            1024: { slidesPerView: 6, spaceBetween: 50 },
          }}
          className="max-w-6xl mx-auto"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {images.map((company, index) => (
            <SwiperSlide key={index} className="flex justify-center items-center">
              <div
                className={`h-32 w-32 mx-4 p-2 rounded-lg ${isHovered ? 'bg-white shadow-md' : 'bg-transparent'}
                transition-all duration-300 transform hover:scale-110 hover:bg-white hover:shadow-lg`}
              >
                <img
                  src={company.logo_url}
                  className="h-full w-full object-contain"
                  loading="lazy"
                />
                <p className="text-xs text-center text-gray-500 mt-2 opacity-0 hover:opacity-100 transition-opacity">
                  {company.business_name}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default LogoCarousel;